<template>
  <div class="container-fluid">
    <div class="row row-sorting-wrapper">
      <div
          class="sorting-item-column sorting-item-column-discovery"
          v-for="(singleSortableData,index) of this.data"
          :key="index"
      >
        <DiscoveryTableSortingSingle
            :data="singleSortableData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SolFileAPIInstance from '@/api'
import DiscoveryTableSortingSingle from './DiscoveryTableSortingSingle'

const order = ['transiting_planet', 'progressed_planet', 'aspect', 'natal_planet', 'house_entry']

export default {
  name: "DiscoveryTableSorting",
  components: {
    DiscoveryTableSortingSingle
  },
  data() {
    return {
      data: []
    }
  },
  methods: {
    async fetchFilters() {
      const response = await SolFileAPIInstance.getDiscoveryFilters()
      const transformedData = Object.entries(response.data).reduce((acc, item) => {
        const [label, values] = item
        const newItem = {
          label,
          values,
          currentValue: ''
        }
        acc.push(newItem)
        return acc
      }, [])
      this.data = order.map(item => {
        return transformedData.find(singleItem => singleItem.label === item)
      })
    }
  },
  mounted() {
    this.fetchFilters()
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$emit('on-sorting-change', this.data)
      }
    }
  }
}
</script>

<style scoped>

</style>